'use strict';

const REQUEST_LOGOUT = '@@auth/REQUEST_LOGOUT';
const LOGOUT_SUCCESS = '@@auth/LOGOUT_SUCCESS';
const LOGOUT_ERROR = '@@auth/LOGOUT_ERROR';

/**
 *
 * @return {ReduxAction}
 */
export function requestLogout() {
  return {
    type: REQUEST_LOGOUT,
    payload: {},
  };
}
requestLogout.TYPE = REQUEST_LOGOUT;

/**
 *
 * @return {ReduxAction}
 */
export function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
    payload: {},
  };
}
logoutSuccess.TYPE = LOGOUT_SUCCESS;

/**
 *
 * @param {Error} err
 * @return {ReduxAction}
 */
export function logoutError(err) {
  return {
    type: LOGOUT_ERROR,
    payload: {
      err,
    },
  };
}
logoutError.TYPE = LOGOUT_ERROR;



// WEBPACK FOOTER //
// ./src/js/auth/actions/logout.js